import React, { useEffect, useState } from 'react';
import { Clock3Icon } from 'lucide-react';
type TimeBlockProps = {
  value: number;
  label: string;
};
function TimeBlock({
  value,
  label
}: TimeBlockProps) {
  return <div className="flex flex-col items-center" data-id="element-85" data-mp="ud87z66bm3j6">
      <div className="flex h-20 w-16 items-center justify-center rounded-xl border border-brand-violet/30 bg-brand-darker text-3xl font-black text-brand-violet shadow-[0_0_20px_rgba(168,85,247,0.14)] sm:h-28 sm:w-24 sm:text-5xl" data-id="element-86" data-mp="ubx2n1x88npy">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-3 text-xs font-semibold uppercase tracking-wider text-gray-400" data-id="element-87" data-mp="3tt53btdh0y9x">{label}</span>
    </div>;
}
export function FreezerCountdown() {
  const [timeLeft, setTimeLeft] = useState(23 * 60 * 60 + 49 * 60 + 56);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setTimeLeft(current => current > 0 ? current - 1 : 0);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8" data-id="element-88" data-mp="1gp6bp28o50dh">
      <div className="relative overflow-hidden rounded-3xl border border-brand-violet/30 bg-brand-card p-7 text-center sm:p-10" data-id="element-89" data-mp="1lossflnpgyr1">
        <div className="absolute left-0 top-0 h-1 w-full bg-brand-darker" aria-hidden="true" data-id="element-90" data-mp="1qo5cxzr3ttqg">
          <div className="h-full w-[68%] bg-brand-violet" data-id="element-91" data-mp="t0n3empmcnle" />
        </div>
        <div className="mx-auto flex max-w-md items-center justify-center gap-2 text-brand-gold" data-id="element-92" data-mp="xz7w812jk4zt">
          <Clock3Icon className="h-5 w-5" aria-hidden="true" data-id="element-93" data-mp="12yb19liiub7s" />
          <p className="text-sm font-bold uppercase tracking-wider" data-id="element-94" data-mp="12wq9g3nld6dm">Precio de lanzamiento</p>
        </div>
        <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-95" data-mp="17qc9mwckjhsj">Cierra en:</h2>
        <div className="mt-8 flex items-start justify-center gap-3 sm:gap-6" data-id="element-96" data-mp="a9dk5lq1qkgm">
          <TimeBlock value={hours} label="Horas" data-id="element-97" data-mp="f7fe51p0g46v" />
          <span className="pt-6 text-3xl font-black text-brand-violet/50 sm:pt-8 sm:text-5xl" data-id="element-98" data-mp="780xcqu86i1k">:</span>
          <TimeBlock value={minutes} label="Min" data-id="element-99" data-mp="36fhqxqb3pno" />
          <span className="pt-6 text-3xl font-black text-brand-violet/50 sm:pt-8 sm:text-5xl" data-id="element-100" data-mp="35xlw27k3dga">:</span>
          <TimeBlock value={seconds} label="Seg" data-id="element-101" data-mp="gxc5ob9afioe" />
        </div>
        <p className="mt-8 inline-flex rounded-full bg-red-500/10 px-4 py-2 text-sm font-medium text-red-300" data-id="element-102" data-mp="by91su51nii0">
          ⚠️ Esta oferta puede estar disponible por tiempo limitado.
        </p>
        <div className="mx-auto mt-6 max-w-md text-left" data-id="element-103" data-mp="3gdh5q32eqcf9">
          <div className="mb-2 flex justify-between text-sm font-bold text-gray-400" data-id="element-104" data-mp="3gf20ntsmvxdn">
            <span data-id="element-105" data-mp="3uebcyidpy7cc">Disponibilidad de lanzamiento</span>
            <span className="text-brand-violet" data-id="element-106" data-mp="3pd46qnr85g7s">Activa</span>
          </div>
          <div className="h-3 overflow-hidden rounded-full border border-brand-violet/20 bg-brand-darker" data-id="element-107" data-mp="19mj294p6ly70">
            <div className="h-full w-[68%] rounded-full bg-brand-violet shadow-[0_0_12px_rgba(168,85,247,0.6)]" data-id="element-108" data-mp="14nom6ailmnql" />
          </div>
        </div>
      </div>
    </section>;
}